export default __webpack_public_path__ + "0f45a89fa72f73997e5f0575627245b2.svg";